import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { formatPrice } from 'utils/price';

import { getPaymentMethodLabel } from 'helpers/paymentMethods';

import { DetailedTransactionFragmentFragment } from 'data/__generated__';
import {
    getPaymentInstrumentId,
    getPaymentMethodTargetPath,
    PaymentIdLink,
    transactionPaymentPath,
} from 'pages/Payments/components/PaymentIdLink';
import { PaymentMethodStatusTag } from './PaymentMethodStatusTag';

export const PaymentMethods = ({
    transactionId,
    paymentMethods,
}: {
    transactionId: string;
    paymentMethods: DetailedTransactionFragmentFragment['paymentMethods'];
}) => {
    return (
        <>
            {paymentMethods?.map((paymentMethod, index) => {
                const {
                    name,
                    paymentMethodName,
                    provider,
                    providerTransactionId,
                    type,
                    amountUsed,
                    status,
                    explanation = '',
                } = paymentMethod;
                const instrumentId = getPaymentInstrumentId(paymentMethod);

                return (
                    <PaymentMethodRow key={index}>
                        <PaymentMethodStatusTag status={status} />
                        <DetailsContainer>
                            <span>
                                {formatPrice(amountUsed || 0)} {getPaymentMethodLabel(paymentMethodName)}
                                {provider && `, fournisseur : ${provider}`}
                                {type && `, type : ${type}`}
                                {name && `, nom : ${name}`}
                                <strong>{explanation && ` : ${explanation}`}</strong>
                            </span>
                            <Identifiers>
                                <PaymentLink to={transactionPaymentPath(transactionId, index)}>
                                    Voir le paiement
                                </PaymentLink>
                                {instrumentId ? (
                                    <span>
                                        ID moyen :{' '}
                                        <PaymentIdLink
                                            id={instrumentId}
                                            to={getPaymentMethodTargetPath(paymentMethod) ?? undefined}
                                            abbreviated={false}
                                        />
                                    </span>
                                ) : null}
                                {providerTransactionId ? (
                                    <span>
                                        ID paiement : <PaymentIdLink id={providerTransactionId} abbreviated={false} />
                                    </span>
                                ) : null}
                            </Identifiers>
                        </DetailsContainer>
                    </PaymentMethodRow>
                );
            })}
        </>
    );
};

const DetailsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
    margin-left: 5px;
`;

const Identifiers = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    font-size: 13px;
    color: ${({ theme }) => theme.infoTextColor};
`;

const PaymentLink = styled(Link)`
    color: ${({ theme }) => theme.ctaPrimaryHoveredColor};
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }
`;

const PaymentMethodRow = styled.div`
    display: flex;
    align-items: baseline;

    &:not(:first-child) {
        margin-top: 5px;
    }
`;
